module.exports = __webpack_public_path__ + "static/media/051.70924435.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/051.wav
 ** module id = 183
 ** module chunks = 0
 **/